import { useQuery } from '@tanstack/react-query'
import { posQuery } from '@/lib/posProxy'
import { Wifi, WifiOff } from 'lucide-react'

export function PosStatusBadge() {
  const { data, isLoading } = useQuery({
    queryKey: ['pos-health'],
    queryFn: async () => {
      try {
        const result = await posQuery<{
          status: string
          sql_connected: boolean
          uptime_seconds: number
        }>('today-sales') // lightweight check
        return { online: result.source === 'live', source: result.source }
      } catch {
        return { online: false, source: 'offline' as const }
      }
    },
    refetchInterval: 60_000, // check every minute
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  })

  if (isLoading) return null

  const online = data?.online ?? false

  return (
    <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
      online
        ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
        : 'bg-amber-50 text-amber-700 border border-amber-200'
    }`}>
      {online ? (
        <>
          <Wifi className="w-3 h-3" />
          <span>POS Live</span>
        </>
      ) : (
        <>
          <WifiOff className="w-3 h-3" />
          <span>POS Offline</span>
        </>
      )}
    </div>
  )
}
